import { FOCUSABLE_ELEMENTS_SELECTOR } from './constants';

/** Helper function to check if an element is inert or within an inert container */
export const isElementInert = (element: HTMLElement): boolean => {
  let currentElement: HTMLElement | null = element;

  while (currentElement) {
    if (currentElement.inert === true) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }

  return false;
};

/** Helper function to find the next focusable element in document order, skipping inert elements and going in reverse if specified */
export const findNextFocusableElement = (triggerElement: HTMLElement, reverse = false): HTMLElement | null => {
  const allFocusableElements = Array.from(document.querySelectorAll<HTMLElement>(FOCUSABLE_ELEMENTS_SELECTOR)).filter(
    (element) => !isElementInert(element),
  );

  const triggerIndex = allFocusableElements.indexOf(triggerElement);

  if (triggerIndex === -1) {
    return allFocusableElements[0] || null;
  }

  if (reverse) {
    return allFocusableElements[triggerIndex - 1] || null;
  } else {
    return allFocusableElements[triggerIndex + 1] || null;
  }
};
